import { modifier } from 'ember-modifier';
import SignaturePad from 'signature_pad';
import { type PointGroup } from 'signature_pad';

export default modifier(
  (
    element: HTMLElement,
    _: [],
    {
      onEnd,
      signaturePoints,
    }: {
      onEnd: (points: PointGroup[], signatureURL: string) => void;
      signaturePoints?: PointGroup[];
    }
  ) => {
    const canvas = element as HTMLCanvasElement;
    const signaturePad = new SignaturePad(canvas, {
      dotSize: 0.1,
      maxWidth: 4,
    });

    function drawSigningLine() {
      const ctx = canvas.getContext('2d');
      if (ctx) {
        const bottomLineY = canvas.height * 0.8;
        ctx.strokeStyle = '#9CA3AF';
        ctx.lineWidth = 1;

        // Draw signing line
        ctx.beginPath();
        ctx.moveTo(50, bottomLineY);
        ctx.lineTo(canvas.width - 50, bottomLineY);
        ctx.stroke();
      }
    }

    function resizeCanvas() {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;

      signaturePad.clear();
      drawSigningLine();

      if (signaturePoints && signaturePoints.length > 0) {
        signaturePad.fromData(signaturePoints);
        drawSigningLine(); // Redraw the line after restoring signature data
      }
    }

    window.addEventListener('resize', resizeCanvas);
    resizeCanvas();

    function _onEnd() {
      if (signaturePad.isEmpty()) {
        return;
      }

      // Temporarily clear the canvas and redraw only the signature data to get clean image
      const currentSignatureData = signaturePad.toData();
      signaturePad.clear();
      signaturePad.fromData(currentSignatureData);

      // Get the clean signature data URL without the grey line
      const cleanSignatureDataURL = signaturePad.toDataURL();

      onEnd(currentSignatureData, cleanSignatureDataURL);

      // Redraw the line for visual guidance
      drawSigningLine();
    }

    signaturePad.addEventListener('endStroke', _onEnd);

    return () => {
      signaturePad.removeEventListener('endStroke', _onEnd);
      window.removeEventListener('resize', resizeCanvas);
    };
  }
);
